<template>
  <div class="register">
    <header>
      <div class="logo">
        <img src="../assets/logo_black.png" alt="">
      </div>
      <div class="operation">
        <router-link to="/">返回首页</router-link>
      </div>
    </header>
    <section>
      <form ref="form" @submit.prevent="_register">
        <div class="content">
          <p class="title">账号注册</p>
          <div class="wordreport">
            <p class="notice-title">湛江仲裁委员会/湛江国际仲裁院告知书</p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、参与仲裁的当事人和代理人应秉持诚实信用和友好合作原则，确保在湛江仲裁委员会/湛江国际仲裁院提供的网络仲裁平台（以下简称“平台”）上所提供的信息和提交的文件真实准确。在进入平台后，所有在平台上发表的文字、语音、视频、图片等都将视为本人操作，当事人将对其所做的操作承担法律责任。
            </p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、当事人和代理人需确保平台上预留的个人信息准确无误。平台上的个人信息仅用于仲裁案件，不会公开披露，除非法律或行政法规另有规定。
            </p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、当事人和代理人应确保提供的联系信息和通讯地址准确无误。申请人需全面、准确地提供被申请人的全部联系方式。</p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、当事人和代理人可以通过平台参与各项仲裁程序，包括但不限于在线提交文件、远程庭审、远程质证等。</p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、当事人和代理人需确保在平台上的行为合法，不得发表与案件无关的言论、视频、图片等。所有在平台上产生的文字、语音、视频、图片等内容以及湛江仲裁委员会收到的任何仲裁文件，不得用于与仲裁无关的其他用途，且不得转发给他人。
            </p>
            <p class="notice-text">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;六、当事人和代理人应妥善保管个人信息，不得向第三方提供。如发现个人信息泄露，请及时联系湛江仲裁委员会/湛江国际仲裁院，以便采取适当措施。
            </p>
          </div>
          <div class="from-item">
            <div :class="{ error: agreeNoticeError }" class="">
              <input type="checkbox" v-model="agreeNotice" id="agreeNotice" name="agreeNotice" value="agreeNotice">
              <label for="agreeNotice"> 我已认真阅读并理解《湛江仲裁委员会/湛江国际仲裁院告知书》的全部内容，并同意进入网络仲裁服务平台</label>
            </div>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">身份信息</h3>
            </div>
            <div class="notice">法人/其他组织的注册通道暂时关闭，请以代理人（员工代理或律师代理）身份注册账号。</div>

            <div class="from-item">
              <p class="required">账号类型</p>
              <div class="radio">
                <input type="radio" id="naturalPerson" name="accountType" value="1" v-model="accountType">
                <label for="naturalPerson">自然人</label>
                <input type="radio" id="lawyer" name="accountType" value="4" v-model="accountType">
                <label for="lawyer">律师/实习律师</label>
              </div>
            </div>

            <div class="from-item">
              <p class="required">姓名</p>
              <div class="input" :class="{ error: userNameError }"><input type="text" v-model="param.userName"
                  placeholder="请输入姓名" /></div>
            </div>

            <div class="from-item">
              <p class="required">国家/地区</p>
              <div class="input select-input" :class="{ error: selectedCountryError }">
                <select class="custom-select" v-model="selectedCountry">
                  <option disabled value="">请选择国家/地区</option>
                  <option v-for="(country, index) in (selectedCountryGroup ? selectedCountryGroup.groupValues : [])"
                    :value="country" :key="'country-' + index">
                    {{ country }}
                  </option>
                </select>
              </div>
            </div>

            <div class="from-item">
              <p class="required">证件名称</p>
              <div class="input select-input" :class="{ error: idTypeError }">
                <select class="custom-select" v-model="param.idType">
                  <option disabled value="">请选择证件名称</option>
                  <option value="1">身份证</option>
                  <option value="0">统一社会信用代码</option>
                  <option value="4">其他证件类型</option>
                </select>
              </div>
            </div>
            <div class="from-item">
              <p class="required"> 证件号码</p>
              <div class="input" :class="{ error: idCardError }"><input type="text" v-model="param.idCard"
                  placeholder="请输入证件号码" /></div>
            </div>
            <div class="from-item">
              <p class="required">法定地址</p>
              <div class="input" :class="{ error: idAddressError }">
                <textarea rows="3" v-model="param.idAddress" placeholder="请输入法定地址"></textarea>
              </div>
            </div>
            <div v-if="accountType == 4" class="from-item">
              <p class="required">律师证件类型</p>
              <div class="input select-input" :class="{ error: lawyerTypeError }">
                <select class="custom-select" v-model="param.lawyerType">
                  <option disabled value="">请选择律师证件类型</option>
                  <option value="0">律师执业证</option>
                  <option value="1">实习律师证</option>
                  <option value="2">律师工作证</option>
                  <option value="3">法律工作者证</option>
                  <option value="4">律师执业证（粤港澳大湾区）</option>
                </select>
              </div>
            </div>
            <div v-if="accountType == 4" class="from-item">
              <p class="required"> 律师证件号码</p>
              <div class="input" :class="{ error: lawyerNoError }"><input type="text" v-model="param.lawyerNo"
                  placeholder="请输入律师证件号码" /></div>
            </div>
            <div v-if="accountType == 4" class="from-item">
              <p class="required"> 所在律师事务所</p>
              <div class="input" :class="{ error: lawyerOfficeError }"><input type="text" v-model="param.lawyerOffice"
                  placeholder="请输入所在律师事务所" /></div>
            </div>
            <div class="from-item">
              <p>职业分类</p>
              <div class="input select-input">
                <select class="custom-select" v-model="param.jobType">
                  <option disabled value="">请选择职业分类</option>
                  <option value="0">政府机构</option>
                  <option value="1">仲裁机构</option>
                  <option value="2">公司企业</option>
                  <option value="3">商协会</option>
                  <option value="4">教学研究</option>
                  <option value="5">其他</option>
                </select>
              </div>
            </div>
            <div class="from-item">
              <p>职务</p>
              <div class="input"><input type="text" v-model="param.position" placeholder="请输入职务" /></div>
            </div>
          </div>

          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">联系方式</h3>
            </div>
            <div class="from-item">
              <p> 电子邮箱</p>
              <div class="input"><input type="text" v-model="param.email" placeholder="请输入电子邮箱" /></div>
            </div>
            <div class="from-item">
              <p> 联系电话</p>
              <div class="input"><input type="text" v-model="param.contractPhone" placeholder="请输入联系电话" /></div>
            </div>
            <div class="from-item">
              <p>通讯地址</p>
              <div class="input">
                <textarea rows="3" v-model="param.mailAddress" placeholder="请输入通讯地址"></textarea>
              </div>
            </div>
          </div>

          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">登录方式</h3>
            </div>
            <div class="from-item">
              <p class="required"> 登录手机号</p>
              <div class="input" :class="{ error: accountError }"><input type="text" v-model="param.account"
                  placeholder="请输入手机号" /></div>
            </div>
            <div class="from-item" >
              <p class="required">图形验证码</p>
              <div class="input">
                <input type="text" v-model="param.imgCode" placeholder="请输入图形验证码" />
                <img :src="verifyImg" alt="点击刷新" @click="refresh" style="cursor: pointer; position: absolute; right: 0; top: 0; height: 100%;" />
              </div>
            </div>
            <div class="from-item">
              <p class="required">手机验证码</p>
              <div class="input" :class="{ error: codeError }">
                <span @click="_getSmsCode" class="click">{{ countDown === -1 ? '获取验证码' : countDown + 's' }}</span>
                <input type="text" v-model="param.code" :placeholder="'请输入手机验证码'" />
              </div>
            </div>
            <div class="from-item">
              <p class="required"> 登录密码</p>
              <div class="input" :class="{ error: passwordError }"><input type="password" v-model="param.password"
                  placeholder="请输入登录密码" /></div>
            </div>
            <div class="from-item">
              <p class="required"> 确认密码</p>
              <div class="input" :class="{ error: confirmPasswordError }"><input type="password"
                  v-model="param.confirmPassword" placeholder="请输入再次登录密码" /></div>
            </div>
          </div>
          <div class="btn">
            <button class="click" type="submit">注册</button>
          </div>
          <p class="reg">
            已有账号？ <router-link to="/login">去登陆</router-link>
          </p>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { getSmsCode, register, getMiniCode, getMiniCodeProgress, CAPTCHA_URL } from '../service/getData'

const captchaUrl = CAPTCHA_URL
// 腾讯验证码配置 - 请替换为您的实际 CaptchaAppId
const TENCENT_CAPTCHA_APP_ID = '198608012'

export default {
  name: 'register',
  data() {
    return {
      countryGroups: [
        { groupName: '热门', groupValues: ['中国', '香港', '澳门', '台湾', '日本', '美国'] },
        { groupName: 'ABCDE', groupValues: ['澳大利亚', '奥地利', '巴西', '德国', '澳门', '俄罗斯', '阿根廷', '白俄罗斯', '丹麦', '爱尔兰', '埃及', '阿富汗', '阿尔巴尼亚', '阿尔及利亚', '安道尔', '安哥拉', '安提瓜和巴布达', '阿塞拜疆', '巴哈马', '巴林', '巴巴多斯', '比利时', '不丹', '玻利维亚', '波黑', '博茨瓦纳', '伯利兹', '保加利亚', '布隆迪', '贝宁', '多米尼克', '多米尼加', '厄瓜多尔', '赤道几内亚', '埃塞俄比亚', '厄立特里亚', '爱沙尼亚', '巴勒斯坦', '冰岛', '朝鲜', '阿曼', '阿鲁巴', '北马里亚纳群岛', '巴基斯坦', '巴拿马', '巴布亚新几内亚', '巴拉圭', '波兰', '东帝汶', '波多黎各', '安圭拉', '多哥', '阿联酋', '布基纳法索', '百慕大', '布韦岛', '佛得角', '奥兰群岛'] },
        { groupName: 'FGHIJ', groupValues: ['加拿大', '法国', '韩国', '捷克', '芬兰', '荷兰', '柬埔寨', '哥伦比亚', '刚果（布）', '刚果（金）', '哥斯达黎加', '古巴', '法属南部领地', '吉布提', '加蓬', '格鲁吉亚', '冈比亚', '加纳', '基里巴斯', '格陵兰', '格林纳达', '瓜德罗普', '几内亚', '圭亚那', '海地', '赫德岛和麦克唐纳群岛', '梵蒂冈', '洪都拉斯', '哈萨克斯坦', '吉尔吉斯斯坦', '黑山', '荷属安的列斯', '菲律宾', '几内亚比绍', '法属圣马丁', '津巴布韦', '法罗群岛', '斐济群岛', '法属圭亚那', '法属波利尼西亚', '关岛', '根西岛'] },
        {
          groupName: 'KLMNO', groupValues: ['马来西亚', '墨西哥', '挪威', '孟加拉', '缅甸', '喀麦隆', '科摩罗', '马约特', '克罗地亚', '南乔治亚岛和南桑威奇群岛', '科特迪瓦', '肯尼亚', '科威特', '老挝', '黎巴嫩', '莱索托', '拉脱维亚', '利比里亚', '利比亚', '列支敦士登', '立陶宛', '卢森堡', '马达加斯加', '马拉维', '马尔代夫', '马里', '马耳他', '马提尼克', '毛里塔尼亚', '毛里求斯', '摩纳哥', '蒙古', '摩尔多瓦', '蒙塞拉特岛', '摩洛哥', '莫桑比克', '纳米比亚', '瑙鲁', '尼泊尔', '尼加拉瓜', '尼日尔', '尼日利亚', '纽埃', '密克罗尼西亚联邦', '马绍尔群岛', '秘鲁', '卡塔尔', '留尼汪', '罗马尼亚', '卢旺达', '南非', '马其顿', '南极洲', '美属萨摩亚', '开曼群岛', '科科斯群岛', '库克群岛', '马尔维纳斯群岛（福克兰）', '诺福克岛', '美国本土外小岛屿', '马恩岛', '美属维尔京群岛']
        },
        {
          groupName: 'PQRST', groupValues: ['瑞士', '葡萄牙', '瑞典', '泰国', '斯里兰卡', '塞浦路斯', '萨尔瓦多', '帕劳', '圣赫勒拿', '圣基茨和尼维斯联邦', '圣卢西亚', '圣皮埃尔和密克隆', '圣文森特和格林纳丁斯', '圣马力诺', '圣多美和普林西比', '沙特阿拉伯', '塞内加尔', '塞尔维亚', '塞舌尔', '塞拉利昂', '斯洛伐克', '斯洛文尼亚', '索马里', '苏丹', '苏里南', '斯瓦尔巴群岛和扬马延岛', '斯威士兰', '塔吉克斯坦', '托克劳', '汤加', '特立尼达和多巴哥', '突尼斯', '土耳其', '土库曼斯坦', '特克斯和凯科斯群岛', '图瓦卢', '坦桑尼亚', '萨摩亚', '所罗门群岛', '圣诞岛', '皮特凯恩群岛', '圣巴泰勒米岛']
        },
        {
          groupName: 'UVWXYZ', groupValues: ['中国', '意大利', '新加坡', '西班牙', '智利', '希腊', '匈牙利', '印度', '印度尼西亚', '新西兰', '亚美尼亚', '文莱', '中非', '乍得', '直布罗陀', '危地马拉', '伊朗', '伊拉克', '以色列', '牙买加', '约旦', '新喀里多尼亚', '瓦努阿图', '越南', '西撒哈拉', '叙利亚', '乌干达', '乌克兰', '乌拉圭', '乌兹别克斯坦', '委内瑞拉', '瓦利斯和富图纳', '也门', '赞比亚', '英属印度洋领地', '英属维尔京群岛', '泽西岛']
        }
      ],
      selectedCountryGroup: { groupName: '热门', groupValues: ['中国', '香港', '澳门', '台湾', '日本', '美国'] },
      selectedCountry: '',
      loginType: 0,
      page: 0,
      countDown: -1,
      sendCodeCount: 0,
      code: '',
      codeStatus: 0,
      uid: '',
      iv: null,
      accountType: 1,
      agreeNotice: false,
      agreeNoticeError: false,
      userNameError: false,
      passwordError: false,
      confirmPasswordError: false,
      accountError: false,
      lawyerOfficeError: false,
      lawyerNoError: false,
      lawyerTypeError: false,
      idAddressError: false,
      idCardError: false,
      idTypeError: false,
      selectedCountryError: false,
      codeError: false,
      param: {
        userName: null,
        idType: '',
        idCard: null,
        idAddress: null,
        jobType: '',
        position: null,
        lawyerNo: null,
        lawyerOffice: null,
        lawyerType: '',
        phone: null,
        email: null,
        contractPhone: null,
        mailAddress: null,
        confirmPassword: null,
        account: null,
        password: null,
        token: null,
        nc_login: 'register',
        sessionId: null,
        sig: null,
        zhiye: '',
        zjlx: '',
        country: '',
        imgCode: null,
        code: null // 短信验证码
      },
      verifyImg: captchaUrl,
      timestamp: null,
      // 腾讯验证码相关
      tencentCaptchaReady: false,
      tencentCaptcha: null
    }
  },
  watch: {
    accountType(newVal, oldVal) {
      // 可选：监听处理
    }
  },
  created() {
    this.refresh()
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    this.loadTencentCaptchaScript()
  },
  mounted() {
    if (this.page === 0) {
      // 阿里滑块已废弃，避免报错，不再调用 initAliCheck
      // this.initAliCheck()
    } else {
      this._getWxCode()
    }
  },
  methods: {
    /**
     * 腾讯验证码脚本加载
     */
    loadTencentCaptchaScript() {
      if (document.querySelector('#tencent-captcha-script')) {
        this.tencentCaptchaReady = true
        this.initTencentCaptcha()
        return
      }
      const script = document.createElement('script')
      script.id = 'tencent-captcha-script'
      script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js'
      script.onload = () => {
        this.tencentCaptchaReady = true
        this.initTencentCaptcha()
      }
      script.onerror = () => {
        console.error('腾讯验证码脚本加载失败')
        this.tencentCaptchaReady = false
      }
      document.head.appendChild(script)
    },
    /**
     * 初始化腾讯验证码
     */
    initTencentCaptcha() {
      if (window.TencentCaptcha && !this.tencentCaptcha) {
        this.tencentCaptcha = new window.TencentCaptcha(TENCENT_CAPTCHA_APP_ID, (res) => {
          if (res.ret === 0) {
            // 验证成功，发送短信
            this.sendSmsWithTicket(res.ticket, res.randstr)
          } else if (res.ret !== 2) {
            this.$message.error('人机验证失败，请重试')
          }
        }, { userLanguage: 'zh-cn' })
      }
    },
    /**
     * 腾讯验证通过后，调用短信发送接口
     */
    async sendSmsWithTicket(ticket, randstr) {
      if (this.countDown !== -1) return
      this.countDown = 120
      this.sendCodeCount += 1
      try {
        const res = await getSmsCode(this.param.imgCode, this.param.account, ticket, randstr, this.timestamp)
        if (res.code === 1) {
          const timer = setInterval(() => {
            if (this.countDown <= 1) {
              clearInterval(timer)
              this.countDown = -1
            } else {
              this.countDown -= 1
            }
          }, 1000)
        } else {
          this.countDown = -1
          this.sendCodeCount = 0
          this.$message.error(res.msg)
          this.refresh() // 刷新图形验证码
        }
      } catch (err) {
        this.countDown = -1
        this.sendCodeCount = 0
        this.$message.error('发送失败，请重试')
        console.error(err)
      }
    },
    /**
     * 阿里滑块初始化（已废弃，保留空函数防止报错）
     */
    initAliCheck() {
      // 阿里滑块不再使用，直接返回

    },
    /**
     * 注册提交
     */
    async _register() {
      var _this = this

      if (!this.agreeNotice) {
        _this.agreeNoticeError = true
        this.$message.error('阅读并勾选告知书内容', 5)
        return false
      } else {
        _this.agreeNoticeError = false
      }

      if (_this.$verify.empty(_this.param.userName)) {
        _this.userNameError = true
        this.$message.error('请输入姓名', 5)
        return false
      } else {
        _this.userNameError = false
      }

      if (_this.$verify.empty(_this.selectedCountry) || _this.selectedCountry === '-1') {
        _this.selectedCountryError = true
        this.$message.error('请选择国家/地区', 5)
        return false
      } else {
        _this.selectedCountryError = false
      }

      if (_this.$verify.empty(_this.param.idType) || _this.param.idType === '-1') {
        _this.idTypeError = true
        this.$message.error('请选择证件名称', 5)
        return false
      } else {
        _this.idTypeError = false
      }

      if (_this.$verify.empty(_this.param.idCard)) {
        _this.idCardError = true
        this.$message.error('请输入证件号码', 5)
        return false
      } else {
        _this.idCardError = false
      }

      if (_this.$verify.empty(_this.param.idAddress)) {
        _this.idAddressError = true
        this.$message.error('请输入法定地址', 5)
        return false
      } else {
        _this.idAddressError = false
      }

      if (this.accountType === 4) {
        if (_this.$verify.empty(_this.param.lawyerType) || _this.param.lawyerType === '-1') {
          _this.lawyerTypeError = true
          this.$message.error('请选择律师证件类型', 5)
          return false
        } else {
          _this.lawyerTypeError = false
        }

        if (_this.$verify.empty(_this.param.lawyerNo)) {
          _this.lawyerNoError = true
          this.$message.error('请输入律师证件号码', 5)
          return false
        } else {
          _this.lawyerNoError = false
        }
        if (_this.$verify.empty(_this.param.lawyerOffice)) {
          _this.lawyerOfficeError = true
          this.$message.error('请输入所在律师事务所', 5)
          return false
        } else {
          _this.lawyerOfficeError = false
        }
      }

      if (!_this.$verify.phone(_this.param.account)) {
        _this.accountError = true
        this.$message.error('请输入正确的登录手机号', 5)
        return false
      } else {
        _this.accountError = false
      }

      // 图形验证码已在获取短信时校验，注册时不再重复校验（但保留以防万一）
      if (_this.$verify.empty(_this.param.imgCode)) {
        this.$message.error('请输入图形验证码')
        return false
      }

      if (_this.$verify.empty(_this.param.code)) {
        _this.codeError = true
        this.$message.error('请输入手机验证码', 5)
        return false
      } else {
        _this.codeError = false
      }

      if (_this.$verify.empty(_this.param.password)) {
        _this.passwordError = true
        this.$message.error('请输入密码', 5)
        return false
      } else {
        _this.passwordError = false
      }

      if (!_this.$verify.vPassword(_this.param.password)) {
        _this.passwordError = true
        this.$message.error('密码必须是6-30个字符', 5)
        return false
      } else {
        _this.passwordError = false
      }

      if (_this.$verify.empty(_this.param.confirmPassword)) {
        _this.confirmPasswordError = true
        this.$message.error('请再次输入密码', 5)
        return false
      } else {
        _this.confirmPasswordError = false
      }

      if (_this.param.confirmPassword !== _this.param.password) {
        _this.confirmPasswordError = true
        _this.passwordError = true
        this.$message.error('两次密码输入不一致', 5)
        return false
      } else {
        _this.confirmPasswordError = false
        _this.passwordError = false
      }

      this.param.userType = this.accountType
      this.param.country = this.selectedCountry
      this.param.phone = this.param.account
      const res = await register(this.param)

      if (res.code === 1) {
        this.$message.success('注册成功')
        this.$router.push('/login')
      } else {
        console.log(res)
        this.$message.error(res.msg, 5)
        if (res.code === 10013) {
          _this.codeError = true
        }
        if (res.code === 10215) {
          _this.idCardError = true
        }
        // 不再调用滑块初始化
      }
    },
    /**
     * 切换登录方式（未使用）
     */
    _switchLoginType() {
      this.loginType = this.loginType === 1 ? 0 : 1
      if (this.loginType === 1) {
        this.param.password = ''
      }
    },
    /**
     * 切换页面（未使用）
     */
    _switchPageType() {
      var _this = this
      if (_this.page === 0) {
        _this.page = 1
        _this._getWxCode()
      } else {
        if (_this.iv !== null) {
          clearInterval(_this.iv)
          _this.code = ''
        }
        _this.page = 0
        this.$nextTick(() => {
          // 阿里滑块已废弃
        })
      }
    },
    /**
     * 获取微信二维码进度（保留）
     */
    getWxCodeProgress() {
      var _this = this
      var time = new Date().getTime() / 1000
      var func = async () => {
        var res = await getMiniCodeProgress(_this.uid)
        if (res.code === 1) {
          if (res.data === 1) {
            _this.codeStatus = 1
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          } else if (res.data === 0) {
            _this.codeStatus = -2
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          }
        }
        if (new Date().getTime() / 1000 - time > 300) {
          _this.codeStatus = -1
          if (this.iv !== null) {
            clearInterval(this.iv)
          }
        }
      }
      func()
      this.iv = setInterval(func, 3000)
    },
    /**
     * 获取小程序二维码（保留）
     */
    async _getWxCode() {
      this.code = ''
      this.codeStatus = 0
      var res = await getMiniCode({ page: 'pages/register/register', scene: 'a=1' })
      if (res.code === 1) {
        this.code = res.data.image
        this.uid = res.data.uid
        this.getWxCodeProgress()
      }
    },
    /**
     * 刷新图形验证码
     */
    refresh() {
      this.timestamp = new Date().getTime()
      this.verifyImg = `${captchaUrl}?t=${this.timestamp}`
    },
    /**
     * 获取短信验证码（新流程：先校验手机号和图形验证码，再弹出腾讯验证码）
     */
    async _getSmsCode() {
      // 1. 校验手机号
      if (!this.$verify.phone(this.param.account)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      // 2. 校验图形验证码
      if (this.$verify.empty(this.param.imgCode)) {
        this.$message.error('请输入图形验证码')
        return false
      }
      if (this.param.imgCode.length !== 5) {
        this.$message.error('图形验证码长度应为5位')
        return false
      }
      // 3. 倒计时中不可获取
      if (this.countDown !== -1) return

      // 4. 确保腾讯验证码组件已就绪
      if (!this.tencentCaptchaReady || !this.tencentCaptcha) {
        this.$message.error('验证码组件未就绪，请刷新页面重试')
        return
      }

      // 5. 弹出腾讯验证码
      this.tencentCaptcha.show()
    }
  },
  destroyed() {
    if (this.iv !== null) {
      clearInterval(this.iv)
    }
  }
}
</script>


<style lang="scss">
@import "../style/mixin";

.register {
  position: relative;
  width: 100%;
  height: 100%;

  section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    &::after {
      content: ' ';
      @include ct;
      background-color: #CEE5F9;
      width: 100%;
      height: 2.917rem;
    }

    .content {
      width: 8rem;
      height: auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.1rem;
      @include center;
      transform: translate(-50%, 0px);
      // position:relative;
      z-index: 2;
      top: 100px;
      box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(14, 37, 61, 0.26);
      position: relative;
      padding-bottom: 0.2rem;

      .required:after {
        content: " *";
        color: red;
      }

      .error {
        border: 1px solid red !important;
      }

      .error-message {
        color: red;
        font-size: 12px;
      }

      .reg {
        margin-top: 0.14rem;
        font-size: 0.15rem;
        color: #999999;

        span {
          color: #3B97E5;
        }
      }

      .panel {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
        margin: 10px;
        padding: 10px;
      }

      .panel-heading {
        position: relative;
        padding-left: 20px;
        /* This creates space for the blue bar */
      }

      .notice {
        margin: 10px;
        background-color: #fff9c4;
        /* A light yellow color */
        color: #333;
        /* A dark gray color for text, you can change it based on your preference */
        padding: 10px;
        /* Padding around the text */
        border-radius: 5px;
        /* Rounded corners */
      }

      .panel-heading:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background-color: lightblue;
        /* Change this to the color you want */
      }

      .panel-title {
        font-weight: bold;
        /* This makes the text bold */
      }

      .title {
        font-size: 0.233rem;
        // margin-top: 0.317rem;
        font-family: PingFang SC;
        font-weight: bold;
        // text-align: center;
        line-height: .8rem;
        margin: 0;
      }

      .wordreport {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.55);
        margin: 20px;
      }

      .notice-title {
        font-size: 0.2rem;
        // margin-top: 0.317rem;
        font-family: PingFang SC;
        font-weight: bold;
        text-align: center;
        line-height: .5rem;
      }

      .notice-text {
        font-size: 0.15rem;
        // margin-top: 0.317rem;
        font-family: PingFang SC;
        // font-weight: bold;
        // text-align: center;
        line-height: .3rem;
      }

      .btn {
        font-size: 0.2rem;
        font-family: PingFang SC;
        font-weight: 500;
        margin-top: 0.252rem;

        button {
          display: block;
          width: 100%;
          background: rgba(59, 151, 229, 1);
          line-height: 0.542rem;
          height: 0.542rem;
          color: #fff;
          box-shadow: 0rem 0.1rem 0.1rem 0rem rgba(10, 13, 47, 0.05);
          border-radius: 0.083rem;
        }
      }

      .alicheck {
        height: 0.542rem;

        #nc {
          line-height: 0.542rem;
          height: 100%;

          ._nc {
            .stage {
              padding: 0;
            }

            .stage1 {
              height: 100%;
              padding: 0;

              .track {
                div {
                  line-height: 0.542rem;
                  height: 100%;
                  font-size: 0.15rem;
                }
              }

              .button {
                height: 100%;
              }

              .slider {
                left: 0;
                right: 0;
                height: 100%;

                .label {
                  height: 100%;
                  line-height: 0.542rem;
                  font-size: 0.15rem;
                }
              }
            }
          }
        }
      }

      .from-item {
        margin-top: 0.123rem;
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          text-align: right;
          padding-right: 30px;
          flex: 1;
          font-size: 0.15rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #000;
          line-height: 0.267rem;
        }

        .radio {
          flex: 5;
          height: auto;
          line-height: 0.542rem;
        }

        .radio input[type="radio"] {
          margin-right: 5px;
        }

        .radio label {
          margin-right: 20px;
          /* 或者你希望的任何其他值 */
        }

        .input {
          flex: 5;
          border-radius: 0.083rem;
          border: 1px solid #EEEEEE;
          height: auto;
          line-height: 0.542rem;
          overflow: hidden;
          // margin-top: 0.168rem;
          position: relative;

          span {
            position: absolute;
            right: 0;
            background-color: #3B97E5;
            padding: 0 0.367rem;
            color: #FFFFFF;
            font-size: 0.15rem;
          }

          input {
            padding: 0 0.167rem;
            height: 100%;
            width: 100%;
            outline: none;
          }
        }

        .input .custom-select {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          padding-right: 30px;
          /* 留更多的空间给自定义箭头 */
          /* 其他样式设置 */
        }

        .select-input-two {
          flex: 2.5;
        }

        .select-input::after {
          content: "";
          position: absolute;
          right: 10px;
          /* 留一些空间在箭头和边缘之间 */
          top: 50%;
          transform: translateY(-50%);
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid black;
          pointer-events: none;
          /* 确保用户点击时不会影响到select元素 */
        }

        .input textarea {
          padding: 0 0.167rem;
          height: auto;
          /* 设置为auto, 以便能根据rows属性自动调整高度 */
          width: 100%;
          outline: none;
          resize: none;
          /* 禁止用户手动调整textarea大小 */
          line-height: 0.25rem;
        }

        .input select {
          padding: 0 0.167rem;
          height: 100%;
          width: 100%;
          outline: none;
          background: white;
          /* 保证下拉菜单的背景是白色 */
          color: black;
          /* 保证下拉菜单的文本是黑色 */
          border: none;
          /* 删除下拉菜单的默认边框 */
        }
      }

      &>* {
        padding: 0 0.2rem;
        margin-bottom: 0.2rem;
      }

    }
  }

  header {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 0.75rem;
    font-size: 0.15rem;
    border-bottom: 0.008rem solid #EEEEEE;

    .logo {
      img {
        width: 2.5rem;
      }
    }

    .operation {
      a {
        color: #333333;
        font-family: PingFang SC;
        font-weight: 500;
      }
    }

    &>div {
      flex: 1
    }
  }
}
</style>
